import { render, staticRenderFns } from "./ViewUserGroupsWithPermissionModal.vue?vue&type=template&id=71959aba&scoped=true&"
import script from "./ViewUserGroupsWithPermissionModal.vue?vue&type=script&lang=ts&"
export * from "./ViewUserGroupsWithPermissionModal.vue?vue&type=script&lang=ts&"
import style0 from "./ViewUserGroupsWithPermissionModal.vue?vue&type=style&index=0&id=71959aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71959aba",
  null
  
)

export default component.exports